// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","primary":"Button_primary__9MLUH","attention":"Button_attention__AcO-C","secondary":"Button_secondary__sUGsj","spinner":"Button_spinner__ZUyM0"};